<template>
   <dashboard-layout>
       <div class="sh-mainpanel"> 
            <div class="sh-pagetitle">
                <div class="input-group">
                <!-- <input type="search" class="form-control" placeholder="Search"> -->
                <span class="input-group-btn">
                    <!-- <button class="btn"><i class="fa fa-search"></i></button> -->
                </span><!-- input-group-btn -->
                </div><!-- input-group -->
                <div class="sh-pagetitle-left">
                <!-- <div class="sh-pagetitle-icon"><i class="icon ion-ios-home"></i></div> -->
                <div class="sh-pagetitle-title"> 
                    <h2>Nieuwe klant</h2>
                </div><!-- sh-pagetitle-left-title -->
                </div><!-- sh-pagetitle-left -->
            </div><!-- sh-pagetitle -->

            <div class="sh-pagebody">
                <div class="row row-sm">
                    <div v-if="loading.msg.length > 0" class="alert alert-info" @click="loading.msg=''">
                        <b>{{loading.msg}}</b>
                        <i class="fa fa-times float-right mt-1"></i>
                    </div>
                    <div class="card bd-primary col-12  mg-t-20">
                        <div class="card-body pd-sm-30">
                            
                            <h2>Adresgegevens:</h2>
                            
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Organisatienaam</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="name" class="form-control" v-model="item.name" @keyup="errors['name']=''; loading.msg='';" @change="errors['name'] = ''; loading.msg=''">
                                    <span v-if="errors['name']">{{ errors['name'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Adres</label>
                                </div>
                                <div class="col-md-6">
                                    <input type="text" name="address" class="form-control" v-model="item.address" @keyup="errors['address']=''; loading.msg='';" @change="errors['address'] = ''; loading.msg=''">
                                    <span v-if="errors['address']">{{ errors['address'] }}</span>
                                </div>
                                <div class="col-md-2">
                                    <input type="text" name="address_number" class="form-control" v-model="item.address_number" @keyup="errors['address_number']=''; loading.msg='';" @change="errors['address_number'] = ''; loading.msg=''">
                                    <span v-if="errors['address_number']">{{ errors['address_number'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Postcode Plaats</label>
                                </div>
                                <div class="col-md-4">
                                    <input type="text" name="zipcode" class="form-control" v-model="item.zipcode" @keyup="errors['zipcode']=''; loading.msg='';" @change="errors['zipcode'] = ''; loading.msg=''">
                                    <span v-if="errors['zipcode']">{{ errors['zipcode'] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <input type="text" name="city" class="form-control" v-model="item.city" @keyup="errors['city']=''; loading.msg='';" @change="errors['city'] = ''; loading.msg=''">
                                    <span v-if="errors['city']">{{ errors['city'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Land)</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="country" class="form-control" v-model="item.country" @keyup="errors['country']=''; loading.msg='';" @change="errors['country'] = ''; loading.msg=''">
                                    <span v-if="errors['country']">{{ errors['country'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Kamer van Koophandel</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="coc" class="form-control" v-model="item.coc" @keyup="errors['coc']=''; loading.msg='';" @change="errors['coc'] = ''; loading.msg=''">
                                    <span v-if="errors['coc']">{{ errors['coc'] }}</span>
                                </div>
                            </div>
                            
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">BTW-Nummer</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="vat" class="form-control" v-model="item.vat" @keyup="errors['vat']=''; loading.msg='';" @change="errors['vat'] = ''; loading.msg=''">
                                    <span v-if="errors['vat']">{{ errors['vat'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Bereken BTW</label>
                                </div>
                                <div class="col-md-8">
                                    <select  name="use_vat" class="form-control" v-model="item.use_vat" @keyup="errors['use_vat']=''; loading.msg='';" @change="errors['use_vat'] = ''; loading.msg=''">
                                        <span v-if="errors['use_vat']">{{ errors['use_vat'] }}</span>
                                        <option value="1">Ja</option>
                                        <option value="0">Nee</option>
                                    </select>
                                </div>
                            </div>


                            <h2>Contactgegevens:</h2>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Telefoonnummer</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="phonenumber" class="form-control" v-model="item.phonenumber" @keyup="errors['phonenumber']=''; loading.msg='';" @change="errors['phonenumber'] = ''; loading.msg=''">
                                    <span v-if="errors['phonenumber']">{{ errors['phonenumber'] }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Mobielnummer</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="mobile" class="form-control" v-model="item.mobile" @keyup="errors['mobile']=''; loading.msg='';" @change="errors['mobile'] = ''; loading.msg=''">
                                    <span v-if="errors['mobile']">{{ errors['mobile'] }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Faxnummer</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="fax" class="form-control" v-model="item.fax" @keyup="errors['fax']=''; loading.msg='';" @change="errors['fax'] = ''; loading.msg=''">
                                    <span v-if="errors['fax']">{{ errors['fax'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Emailadres</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="email" name="email" class="form-control" v-model="item.email" @keyup="errors['email']=''; loading.msg='';" @change="errors['email'] = ''; loading.msg=''">
                                    <span v-if="errors['email']">{{ errors['email'] }}</span>
                                </div>
                            </div>


                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Emailadres Financien</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="email" name="email_financial" class="form-control" v-model="item.email_financial" @keyup="errors['email_financial']=''; loading.msg='';" @change="errors['email_financial'] = ''; loading.msg=''">
                                    <span v-if="errors['email_financial']">{{ errors['email_financial'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Emailadres Support</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="email" name="email_support" class="form-control" v-model="item.email_support" @keyup="errors['email_support']=''; loading.msg='';" @change="errors['email_support'] = ''; loading.msg=''">
                                    <span v-if="errors['email_support']">{{ errors['email_support'] }}</span>
                                </div>
                            </div>

                            <h2>Financiele gegevens:</h2>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">IBAN accountnaam</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="iban_accountname" class="form-control" v-model="item.iban_accountname" @keyup="errors['iban_accountname']=''; loading.msg='';" @change="errors['iban_accountname'] = ''; loading.msg=''">
                                    <span v-if="errors['iban_accountname']">{{ errors['iban_accountname'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">IBAN accountnummer</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="iban" class="form-control" v-model="item.iban" @keyup="errors['iban']=''; loading.msg='';" @change="errors['iban'] = ''; loading.msg=''">
                                    <span v-if="errors['iban']">{{ errors['iban'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">BIC code</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="bic" class="form-control" v-model="item.bic" @keyup="errors['bic']=''; loading.msg='';" @change="errors['bic'] = ''; loading.msg=''">
                                    <span v-if="errors['bic']">{{ errors['bic'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Betaaltermijn</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" name="term_of_payment" class="form-control" v-model="item.term_of_payment" @keyup="errors['term_of_payment']=''; loading.msg='';" @change="errors['term_of_payment'] = ''; loading.msg=''">
                                    <span v-if="errors['term_of_payment']">{{ errors['term_of_payment'] }}</span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label class="col-form-label">Kredietlimiet</label>
                                </div>
                                <div class="input-group col-md-8">
                                    <span class="input-group-addon">€</span>
                                    <input type="text" name="credit_limit" class="form-control" v-model="item.credit_limit" @keyup="errors['credit_limit']=''; loading.msg='';" @change="errors['credit_limit'] = ''; loading.msg=''">
                                    <span v-if="errors['credit_limit']">{{ errors['credit_limit'] }}</span>
                                </div>
                            </div>

                            <h2>Diversen</h2>
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <span class="col-form-label">Klanttype</span>
                                </div>
                                <div class="col-lg-8">
                                        <select class="form-control" id="type" v-model="item.type" @keyup="errors['type']=''; loading.msg='';" @change="errors['type'] = ''; loading.msg=''">
                                            <span v-if="errors['type']">{{ errors['type'] }}</span>
                                            <option value="Winkel">Winkel</option>
                                            <option value="Groothandel">Groothandel</option>
                                            <option value="Tussenhandel">Tussenhandel</option>
                                        </select>
                                </div>
                            </div>
        
                            <div class="form-group row">
                                <div class="col-md-4">
                                </div>
                                <div class="col-md-8">
                                    <button @click="createDebtor()" class="btn btn-success">Maak nieuwe klant</button>
                                </div>
                            </div>
                        </div><!-- card-body -->
                    </div> 
                </div>
            </div>
       </div>
   </dashboard-layout>
</template>

<script>
import dashboardLayout from '../layouts/dashboard_layout'

import { mapState } from 'vuex'
export default {
    name:'create_debtor',
    components:{
        dashboardLayout
    },
    computed:{
        ...mapState({
            loading:(state)=>state.loading,
            endpoint:(state)=>state.endpoint,
        })
    },
    data(){
        return {
            item:{
                name    : '',
                address : '',
                address_number  : '',
                zipcode : '',
                city    : '',
                country : '',
                coc : '',
                vat : '',
                phonenumber : '',
                mobile  : '',
                fax : '',
                email   : '',
                email_financial : '',
                email_support   : '',
                iban_accountname    : '',
                iban    : '',
                bic : '',
                term_of_payment : '',
                credit_limit    : '',
                type:'Winkel',
                use_vat:1,
            },
            errors:{

            }
        }
    },
    created(){
    },
    mounted(){ 
    },
    methods:{
        createDebtor(){  
            this.$store.state.loading.status=true;
            this.$store.dispatch('post',{details:this.item,endpoint:this.endpoint+'vue/organizations'})
            .then((data)=>{
                console.log(data);
                this.$store.state.loading.status=false;
                if(data.data.errors){
                    var new_errors = Object.keys(data.data.errors).map(function(key) {
                      return {
                        'item'  : key, 
                        'msg'   : data.data.errors[key][0]
                      }
                    });

                    var errors = {};
                    new_errors.forEach(function(error){
                        errors[error.item] = error.msg;
                    });
                    this.errors = errors;
                    this.$store.state.loading.msg="Klant kon niet aangemaakt worden...";
                    window.scrollTo(0, 0);
                }else{
                    window.location.href="edit-debtor/"+data.data.id;
                }
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
                this.$store.state.loading.msg="Klant kon niet aangemaakt worden...";
                window.scrollTo(0, 0);
            });
        },


    }
}
</script>